// extracted by mini-css-extract-plugin
export default {"icon":"sideMenu_icon__QD7J9","item":"sideMenu_item__0yCCp","active":"sideMenu_active__+moIu","image":"sideMenu_image__2Q52y","fs-24":"sideMenu_fs-24__z+Q+A"};